
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sc-kPQfTP bgIxIp",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.692 8.754l1.616 1.492-6 6.5a1.1 1.1 0 01-1.586.032l-4.5-4.5 1.556-1.556 3.69 3.69 5.224-5.658z","fill":"currentColor"}})])
          )
        }
      }
    